import { useEffect, useState } from 'react';

const navItems = [
  { id: 'updates', label: '今日更新' },
  { id: 'hot', label: '热门新片' },
  { id: 'series', label: '追更专区' },
  { id: 'rank', label: '热度榜' },
  { id: 'categories', label: '分类导航' },
  { id: 'guide', label: '追更指南' },
  { id: 'faq', label: '常见问题' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-2 md:gap-3 shrink-0">
          <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-movie-2-line text-lg md:text-xl" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base md:text-lg font-bold text-foreground-950">蓝莓视频</span>
            <span className="text-[10px] md:text-xs text-foreground-600 mt-1">资源更新速递</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1" aria-label="页面分区导航">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="px-3 py-2 text-sm text-foreground-800 rounded-md hover:bg-primary-100 hover:text-primary-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#updates"
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-flashlight-line" aria-hidden="true"></i>
            看最新更新
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            aria-label={open ? '收起导航菜单' : '展开导航菜单'}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-900 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open ? (
        <nav
          className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3 grid grid-cols-2 gap-2"
          aria-label="移动端分区导航"
        >
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={() => setOpen(false)}
              className="px-3 py-2 text-sm text-foreground-800 rounded-md bg-background-100 hover:bg-primary-100 hover:text-primary-800 transition-colors cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>
      ) : null}
    </header>
  );
}